import React from "react";

const AadhaarPreview = ({
  aadhaarNumber,
  aadhaarName,
  frontPreview,
  backPreview,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Preview Details</h3>

      <div>
        <p className="font-medium">Aadhaar Number:</p>
        <p className="text-gray-800">{aadhaarNumber || "N/A"}</p>
      </div>

      <div>
        <p className="font-medium">Full Name:</p>
        <p className="text-gray-800">{aadhaarName || "N/A"}</p>
      </div>

      <div>
        <p className="font-medium">Front Image:</p>
        {frontPreview ? (
          <img
            src={frontPreview}
            alt="Aadhaar Front"
            className="w-full rounded"
          />
        ) : (
          <p className="text-sm text-gray-500">No front image uploaded.</p>
        )}
      </div>

      <div>
        <p className="font-medium">Back Image:</p>
        {backPreview ? (
          <img
            src={backPreview}
            alt="Aadhaar Back"
            className="w-full rounded"
          />
        ) : (
          <p className="text-sm text-gray-500">No back image uploaded.</p>
        )}
      </div>
    </div>
  );
};

export default AadhaarPreview;
